<template>
  <div id="app">
    <div class="bar">
      <tasty-burger-button
        type="collapse"
        color="#4D4D4D"
        active-color="#D9AF91"
        @toggle="switchMenu"
        :active="switchIcon"
        class="bar__toggle"
      />
    </div>
    <transition name="slide">
      <div class="menu" v-if="activeMenu" @click="closeMenu">
        <div>
          <h3>Menu</h3>
          <a
            v-for="(item, index) in menuItems"
            :key="index"
            :class="item.class"
            :href="item.url"
          >{{item.name}}</a>
        </div>
      </div>
    </transition>
    <router-view />
    <footer>
      <div>
        <h3>Ing. arch. Břetislav Krejsa</h3>
        <div>© 2020 Břetislav Krejsa. Všechna práva vyhrazena.</div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ww: window.innerWidth,
      sm: null,
      md: null,
      lg: null,
      xl: null,
      activeMenu: false,
      switchIcon: false,
      activeColor: "#D9AF91",
      menuItems: [
        { name: "Domů", url: "/", class: "menu__link" },
        { name: "Moje zaměření", url: "/#moje-zamereni", class: "menu__link" },
        {
          name: "Urbanismus a územní plánování",
          url: "urbanismus",
          class: "menu__link-2",
        },
        { name: "Architektura", url: "architektura", class: "menu__link-2" },
        {
          name: "Fotografie a grafický design",
          url: "grafika",
          class: "menu__link-2",
        },
        { name: "O mně", url: "/#o-mne", class: "menu__link" },
        { name: "Napište mi", url: "/#napiste-mi", class: "menu__link" },
        { name: "Kontakt", url: "/#kontakt", class: "menu__link" },
        { name: "Blog", url: "blog", class: "menu__link" },
      ],
    };
  },
  methods: {
    mediumSize: function (ww) {
      this.sm = ww < 400;
      this.md = ww >= 400 && ww < 800;
      this.lg = ww >= 800 && ww < 1200;
      this.xl = ww >= 1200;
    },
    switchMenu: function() {
      this.activeMenu = !this.activeMenu;
    },
    closeMenu: function() {
      this.switchIcon = !this.switchIcon;
    }
  },
  mounted() {
    this.mediumSize(this.ww);
    window.onresize = () => {
      this.ww = window.innerWidth;
      this.mediumSize(this.ww);
    };
  }
};
</script>
<style>
/* ZÁKLADNÍ HTML */
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #e5e5e5;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background-color: #9c9c9c;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background-color: #d9af91;
}

body {
  margin: 0;
  font-family: atten-new, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #9c9c9c;
}

input,
textarea {
  font-family: atten-new, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: #9c9c9c;
}

a,
a > h3,
button {
  text-decoration: none;
  opacity: 1;
  transition: all 0.15s ease-in-out;
  color: #4d4d4d;
}

a:hover > img {
  opacity: 0.8;
  transition: all 0.15s ease-in-out;
  color: #d9af91;
}

a:hover,
a:hover > h3,
button:hover {
  transition: all 0.15s ease-in-out;
  color: #d9af91;
}

a.btn,
button.btn {
  background-color: #4d4d4d;
  border: none;
  border-radius: 16px;
  color: white;
  cursor: pointer;
  padding: 12px 32px;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  display: inline-block;
}

button.btn:focus {
  outline: none;
  box-shadow: none;
}

.btn.btn-primary {
  background-color: #0a1930;
}

.btn.btn-primary:hover {
  background-color: #d9af91;
}

/* NADPISY */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: atten-new, sans-serif;
  font-weight: 500;
  font-style: normal;
  color: #4d4d4d;
}

h1 {
  font-size: 7rem;
  letter-spacing: 0.5rem;
}

h2 {
  font-size: 4rem;
}

h3 {
  font-size: 26px;
  text-transform: uppercase;
}

/* BLOKY */
.bar {
  width: 100%;
  position: fixed;
  top: 10px;
  right: 6px;
  text-align: right;
  z-index: 999 !important;
}

.menu {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  background-color: #fff;
  z-index: 2;
  box-shadow: 0 0 48px #4d4d4d;
}

.menu::after {
  content: " ";
  display: block;
  background-color: #fff;
  height: 48px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}

.menu > div {
  padding: 48px;
}

.menu__link {
  display: block;
  padding: 8px 0;
  color: #4d4d4d;
  font-weight: 500;
}

.menu__link-2 {
  display: block;
  padding: 8px;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.8s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}

@media only screen and (max-width: 800px) {
  h1 {
    font-size: 4rem;
  }

  h2 {
    font-size: 48px;
  }
}

@media only screen and (max-width: 400px) {
  h1 {
    font-size: 3rem;
    letter-spacing: 0.2rem;
  }

  h2 {
    font-size: 36px;
  }
}

@media only screen and (min-width: 400px) {
  .menu {
    width: 400px !important;
  }
}

footer {
  width: 100%;
  padding: 144px 0px;
  position: relative;
  left: 0;
  bottom: 0;
  text-align: center;
}

/* FONTY */
/* Atten New Regular*/
.--regular {
  font-family: atten-new, sans-serif;
  font-weight: 400;
  font-style: normal;
}

/* Atten New Regular Italic */
.--regular-italic {
  font-family: atten-new, sans-serif;
  font-weight: 400;
  font-style: italic;
}

/* Atten New Medium */
.--medium {
  font-family: atten-new, sans-serif;
  font-weight: 500;
  font-style: normal;
}

/* Atten New Medium Italic*/
.--medium-italic {
  font-family: atten-new, sans-serif;
  font-weight: 500;
  font-style: italic;
}

/* Atten New Bold */
.--bold {
  font-family: atten-new, sans-serif;
  font-weight: 700;
  font-style: normal;
}

/* Atten New Bold Italic */
.--bold-italic {
  font-family: atten-new, sans-serif;
  font-weight: 700;
  font-style: italic;
}

/* ÚPRAVY TEXTU */
.--text-center {
  text-align: center;
}

.--text-left {
  text-align: left;
}

.--color-pink {
  color: #d9af91;
}

.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.5s infinite ease-in-out;
  animation: load7 1.5s infinite ease-in-out;
}
.loader {
  color: #d9af91;
  font-size: 10px;
  margin: 80px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  content: "";
  position: absolute;
  top: 0;
}
.loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 3.5em;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
</style>
